import _ from 'lodash';
import Skeleton from 'react-loading-skeleton';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import MaxWidthContainer from 'components/MaxWidthContainer';
import WebpImg from 'components/WebpImg';
import useRWD from 'hooks/useRWD';
import { Carousel } from 'react-responsive-carousel';

const HomeMiniBanner = (props) => {
  const { isLoading, banners, setActiveIndex, index } = props;
  const { isLg } = useRWD();
  const chunkMiniBanners = _.chunk(banners, 4);
  const carouselInterval = isLg ? 2000 : 1500;

  return (
    <>
      {(isLoading || banners.length > 0) && (
        <MaxWidthContainer className="mt-6 px-4 lg:mt-12">
          <div className="text-xl font-bold text-[#111928] lg:text-2xl">
            Sorra會員專屬內容
          </div>
          <div className="relative -mx-4 flex overflow-hidden pr-20 pt-4 lg:hidden">
            {isLoading ? (
              <div className="flex h-[130px] w-full gap-x-2.5 overflow-visible pl-4">
                {[0, 1].map((i) => {
                  return (
                    <Skeleton
                      key={`mini-banner-${i}`}
                      className="aspect-[306/170] h-full rounded-lg"
                    />
                  );
                })}
              </div>
            ) : (
              <div className="mobile-mini-banner-carousel relative w-full pl-4">
                <Carousel
                  swipeable={true}
                  emulateTouch={true}
                  autoPlay={true}
                  infiniteLoop={banners.length > 1}
                  interval={carouselInterval}
                  stopOnHover={true}
                  showIndicators={false}
                  showArrows={false}
                  showStatus={false}
                  showThumbs={false}
                >
                  {banners.map((banner) => {
                    // const { image } = banner;
                    const { id, images, url = null, new_tab = false } = banner;
                    const imageUrl = (banner) => {
                      const primaryField = isLg ? 'image' : 'mobile_image';
                      const fallbackField = isLg ? 'mobile_image' : 'image';

                      return (
                        _.find(banner.images, { field: primaryField })?.url ||
                        _.find(banner.images, { field: fallbackField })?.url ||
                        ''
                      );
                    };
                    return (
                      <div key={`mini-banner-${banner.id}`} className="pr-2.5">
                        <div
                          className="aspect-[306/170] cursor-pointer overflow-hidden rounded-lg"
                          onClick={() => {
                            if (banner.url) {
                              window.open(
                                banner.url,
                                banner.new_tab ? '_blank' : ''
                              );
                            }
                          }}
                        >
                          <WebpImg
                            src={imageUrl(banner)}
                            className="h-full w-full object-cover"
                          />
                        </div>
                      </div>
                    );
                  })}
                </Carousel>
              </div>
            )}
          </div>
          <div className="mini-banner-carousel relative hidden pt-7 lg:block">
            {isLoading ? (
              <div className="grid grid-cols-4 gap-x-4">
                {[0, 1, 2, 3].map((i) => {
                  return (
                    <Skeleton
                      key={`mini-banner2-${i}`}
                      className="aspect-[306/170] rounded-lg"
                    />
                  );
                })}
              </div>
            ) : (
              <Carousel
                swipeable={true}
                emulateTouch={true}
                autoPlay={true}
                infiniteLoop={chunkMiniBanners.length > 1}
                interval={carouselInterval}
                stopOnHover={true}
                showIndicators={false}
                showStatus={false}
                showThumbs={false}
                onChange={setActiveIndex}
                renderArrowPrev={(clickHandler, hasPrev, labelPrev) => {
                  return (
                    index !== 0 && (
                      <button
                        onClick={clickHandler}
                        className="absolute -left-6 top-1/2 z-10 h-10 w-10 -translate-x-full -translate-y-1/2 rounded-full"
                        style={{
                          boxShadow:
                            '0px 5px 7.5px -1.25px rgba(0, 0, 0, 0.1), 0px 2.5px 5px -2.5px rgba(0, 0, 0, 0.05)',
                        }}
                      >
                        <img
                          className="p-2.5"
                          src="/svgs/index-horizontalScroll-arrowLeft.svg"
                        ></img>
                      </button>
                    )
                  );
                }}
                renderArrowNext={(clickHandler, hasNext, labelNext) => {
                  return (
                    index !== chunkMiniBanners.length - 1 && (
                      <button
                        onClick={clickHandler}
                        className="absolute -right-6 top-1/2 z-10 h-10 w-10 -translate-y-1/2 translate-x-full rounded-full"
                        style={{
                          boxShadow:
                            '0px 5px 7.5px -1.25px rgba(0, 0, 0, 0.1), 0px 2.5px 5px -2.5px rgba(0, 0, 0, 0.05)',
                        }}
                      >
                        <img
                          className="p-2.5"
                          src="/svgs/index-horizontalScroll-arrowRight.svg"
                        ></img>
                      </button>
                    )
                  );
                }}
              >
                {chunkMiniBanners.map((chunk, index) => {
                  const { images, id } = chunk;
                  const chunkKey = `chunk-${index}-${chunkMiniBanners[0]?.id || index}`;
                  const imageUrl = (banner) => {
                    const primaryField = isLg ? 'image' : 'mobile_image';
                    const fallbackField = isLg ? 'mobile_image' : 'image';
                    return (
                      _.find(banner.images, { field: primaryField })?.url ||
                      _.find(banner.images, { field: fallbackField })?.url ||
                      ''
                    );
                  };
                  return (
                    <div key={chunkKey} className="grid grid-cols-4 gap-x-4">
                      {chunk.map((banner, index) => {
                        return (
                          <div
                            key={`chunk-mini-banner-${index}`}
                            className="aspect-[306/170] cursor-pointer overflow-hidden rounded-lg"
                            onClick={() => {
                              if (banner.url) {
                                window.open(
                                  banner.url,
                                  banner.new_tab ? '_blank' : ''
                                );
                              }
                            }}
                          >
                            <WebpImg
                              src={imageUrl(banner)}
                              className="h-full w-full object-cover"
                            />
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </Carousel>
            )}
          </div>
        </MaxWidthContainer>
      )}
      {/******** */}
    </>
  );
};

export default HomeMiniBanner;
